<div class="icons-container">
  <div class="icon-wrapper" *ngFor="let i of icons" (click)="copyToClipboard(i)">
    <app-svg class="display-size" [name]="i"></app-svg>
    <div>{{ i }}</div>
  </div>
</div>
